import React, { useState } from 'react';
import { ToggleSwitch } from 'flowbite-react';
import { useCompanyStore } from '../../../state/useCompanyStore';
import SuccessBanner from '../../common/Banner/SuccessBanner';
import { RestockAlertSettings } from './RestockAlertSetting'; 
import { WeeklyReportSettings } from './WeeklyReportSettings';
import { useUserStore } from '../../../state';

// Define default settings structure
const DEFAULT_NOTIFICATION_SETTINGS = {
  restockAlert: { stock: 5, channels: ['email'], enabled: false },
  marketing: { enabled: false },
  weeklyReport: { email: [] }
};

function NotificationSettings() {
  const { company, updateNotificationSettings } = useCompanyStore();
  const { user } = useUserStore();
  
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);
  const [bannerMessage, setBannerMessage] = useState('');

  // Get settings from company or use defaults
  const notificationSettings = company.notificationSettings || DEFAULT_NOTIFICATION_SETTINGS;

  const handleSettingsChange = async (newSettings: typeof notificationSettings) => {
    try {
      await updateNotificationSettings(newSettings);
    } catch (error) {
      console.error('Failed to update notification settings:', error);
      showBanner('Failed to update settings');
    }
  };

  const showBanner = (message: string) => {
    setBannerMessage(message);
    setShowSuccessBanner(true);
    setTimeout(() => setShowSuccessBanner(false), 5000);
  };

  const handleCloseBanner = () => {
    setShowSuccessBanner(false);
  };

  return (
    <>
      <div className="flex flex-col gap-2">
        <h1 className="text-xl font-semibold">Notification</h1>
        <p className="">
          Customize your notification preferences to receive timely updates on
          stock levels, orders, and important alerts.
        </p>
      </div>
      <hr className="my-4" />

      {showSuccessBanner && (
        <SuccessBanner message={bannerMessage} onClose={handleCloseBanner} />
      )}

      <RestockAlertSettings
        settings={notificationSettings}
        onSettingsChange={handleSettingsChange}
        showBanner={showBanner}
      />

      <WeeklyReportSettings
        settings={notificationSettings}
        userEmail={company.email}
        onSettingsChange={handleSettingsChange}
        showBanner={showBanner}
      />

      <hr className="my-4" />

      <div className='flex flex-col gap-2'>
        <div className='flex items-center gap-4'>
          <h1 className='text-xl font-semibold'>Receive Newsletters</h1>
          <ToggleSwitch 
            checked={notificationSettings.marketing?.enabled || false} 
            onChange={async (checked) => {
              const updatedSettings = {
                ...notificationSettings,
                marketing: {
                  enabled: checked,
                },
              };
              await handleSettingsChange(updatedSettings);
              showBanner(checked ? 
                'Marketing communications enabled successfully' : 
                'Marketing communications disabled successfully');
            }} 
          />
        </div>
        <p className="">
          I agree to receive marketing communications from Esemie and understand
          I can unsubscribe anytime.
        </p>
      </div>

      <hr className="my-4" />
    </>
  );
}

export default NotificationSettings;
